import React, { memo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

function FAQMap() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const faqItems = t("faq.items", { returnObjects: true });

  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("faq.seoTitle")}</title>
        <meta name="description" content={t("faq.seoDescription")} />
        <meta name="keywords" content={t("faq.seoKeywords")} />
        <meta property="og:title" content={t("faq.seoTitle")} />
        <meta property="og:description" content={t("faq.seoDescription")} />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="border-top border-2" dir={isArabic ? "rtl" : "ltr"}>
        <div className="my-5 container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <h2 className="text-center my-4">{t("faq.title")}</h2>
              <div className="accordion bg-light rounded" id="accordionExample">
                {faqItems.map((item, index) => (
                  <div className="accordion-item border-bottom" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button
                        className={`accordion-button ${
                          openIndex === index ? "" : "collapsed"
                        }`}
                        type="button"
                        onClick={() => toggleItem(index)}
                      >
                        <div className="d-flex justify-content-between align-items-center w-100 text-end">
                          <span>{item.question}</span>
                          <span>
                            <i
                              className={`bi ${
                                openIndex === index
                                  ? "bi-dash-lg"
                                  : "bi-plus-lg"
                              }`}
                            ></i>
                          </span>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse${index}`}
                      className={`accordion-collapse collapse ${
                        openIndex === index ? "show" : ""
                      }`}
                      aria-labelledby={`heading${index}`}
                    >
                      <div className="accordion-body">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-6 col-md-12 mb-4">
              <h2 className="text-center my-4">{t("faq.mapTitle")}</h2>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3386.788549917203!2d35.203975675627376!3d31.91234207403698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzHCsDU0JzQ0LjQiTiAzNcKwMTInMjMuNiJF!5e0!3m2!1sen!2seg!4v1756872337700!5m2!1sen!2seg"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Saleem Smile Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(FAQMap);
